"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const getPar_1 = __importDefault(require("../apiBucket/getPar"));
const AccessType_enum_1 = require("../ts/enums/AccessType.enum");
const BucketListingAction_enum_1 = require("../ts/enums/BucketListingAction.enum");
const stringUtils_1 = require("../utils/stringUtils");
const getFileList = (filePath, options, isBeCall) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const getParBody = {
            name: options === null || options === void 0 ? void 0 : options.name,
            objectName: filePath,
            accessType: AccessType_enum_1.AccessType.ANY_OBJECT_READ,
            urlValiditySeconds: options === null || options === void 0 ? void 0 : options.urlValiditySeconds,
            bucketListingAction: BucketListingAction_enum_1.BucketListingAction.LIST_OBJECTS,
        };
        // Recupero il par autorizzato per richiedere la lista di file contenute
        // nel path filePath
        const parResponse = yield (0, getPar_1.default)(getParBody, isBeCall);
        const parData = parResponse.data;
        const { accessUri } = parData;
        // Recupero la lista dei file
        const fileListResponse = yield axios_1.default.get(`${accessUri}?fields=name,timeCreated,md5,timeModified`);
        const fileListData = yield fileListResponse.data;
        // Rimuovo l'elemento che contiene il path della cartella
        const fileListFiltered = fileListData === null || fileListData === void 0 ? void 0 : fileListData.objects.filter((el) => el.name !== filePath);
        // Creo l'array di risposta con i vari file
        const fileList = fileListFiltered.map((el) => {
            return {
                url: `${accessUri}${el.name}`,
                name: (0, stringUtils_1.getFileNameFromUrl)(el.name),
                raw: Object.assign({}, el),
            };
        });
        return fileList;
    }
    catch (error) {
        console.log(error);
        return null;
    }
});
exports.default = getFileList;
